/// <reference path="appbase.ts" />
/// <reference path="app_settings.ts" />

namespace TerminalApp {

    export class ShipmentInfoDialog {
        container = document.getElementById("oid");
        oid_order_data = document.getElementById("oid_order_data");
        oid_recipient = document.getElementById("oid_recipient");
        oid_sender = document.getElementById("oid_sender");
        oid_items = document.getElementById("oid_items");
        oid_labels = document.getElementById("oid_labels");
        oid_close = document.getElementById("oid_close");
        oid_delivery_methods = document.getElementById("oid_delivery_methods") as HTMLSelectElement;
        oid_parcel_type = document.getElementById("oid_parcel_type") as HTMLSelectElement;
        oid_print_extra_button = document.getElementById("oid_print_extra_button");
        oid_print_note_button = document.getElementById("oid_print_note_button");
        oid_extra_width = document.getElementById("oid_extra_width") as HTMLInputElement;
        oid_extra_length = document.getElementById("oid_extra_length") as HTMLInputElement;
        oid_extra_height = document.getElementById("oid_extra_height") as HTMLInputElement;
        oid_extra_weight = document.getElementById("oid_extra_weight") as HTMLInputElement;
        customer: SP.CustomerInfo;
        shipment: SP.ShipmentInfo;
        constructor() {
            this.oid_close.addEventListener("click", () => {
                this.close();
            });


            this.oid_print_extra_button.addEventListener("click", () => {
                this.printExtra();

            });

            this.oid_print_note_button.addEventListener("click", () => {
                this.printDeliveryNote();
            });

            this.oid_delivery_methods.addEventListener("change", () => {
                this.updateParcelTypes();
            });
        }

        updateParcelTypes() {
            var method = this.customer.deliveryMethods[this.oid_delivery_methods.value];
            var parcelTypes = method != null ? method.parcelTypes.filter(pt => pt.enabled) : [];
            this.oid_parcel_type.innerHTML = "";


            parcelTypes.forEach(pt => {
                var opt = document.createElement("option");
                opt.text = pt.name;
                opt.value = pt.code;
                this.oid_parcel_type.appendChild(opt);
            });
        }

        async load(shipmentId: string) {
            this.container.style.display = "block";
            var shipment = this.shipment = await SP.Data.Shipment.getShipmentInfo(shipmentId);
            var customer = this.customer = await SP.Data.Customer.getCustomerInfo(shipment.order.customerId, true);

            this.oid_order_data.innerHTML =
                "<b style='color: #fff'>OrderId: " + shipment.order.orderId + "</b> <br />" +
                "<b>OrderNo:</b> " + shipment.order.orderNo + "<br />" +
                "<b>DeliveryMethod:</b> " + shipment.order.deliveryMethodInfo.name + " (" + shipment.order.deliveryMethodInfo.shortName + ")<br />";

            this.oid_recipient.innerHTML =
                shipment.order.recipient.name + "<br />" +
                (shipment.order.recipient.attention ? shipment.order.recipient.attention + "<br />" : "") +
                shipment.order.recipient.street1 + "<br />" +
                (shipment.order.recipient.street2 ? shipment.order.recipient.street2 + "<br />" : "") +
                shipment.order.recipient.zipcode + " " + shipment.order.recipient.city + ", " + shipment.order.recipient.country + "<br />" +
                shipment.order.recipient.email + " / " + shipment.order.recipient.phone;

            this.oid_sender.innerHTML =
                shipment.order.sender.name + "<br />" +
                (shipment.order.sender.attention ? shipment.order.sender.attention + "<br />" : "") +
                shipment.order.sender.street1 + "<br />" +
                (shipment.order.sender.street2 ? shipment.order.sender.street2 + "<br />" : "") +
                shipment.order.sender.zipcode + " " + shipment.order.sender.city + ", " + shipment.order.sender.country + "<br />" +
                shipment.order.sender.email + " / " + shipment.order.sender.phone;


            //clear
            this.oid_items.innerHTML = "";

            for (let i = 0; i < shipment.lines.length; i++) {
                let line = shipment.lines[i];
                let name = line.orderLine.itemInfo.sku + " - " + line.orderLine.itemInfo.manufacturerName + " " + line.orderLine.itemInfo.modelNo;
                this.oid_items.innerHTML +=
                    "<div class='box item'>" +
                    "<img src='" + line.orderLine.itemInfo.imageUrl + "'> " +
                    "<span class='details'> <b style='color: #fff'>" + name + "</b><br /><small>" + line.orderLine.itemInfo.description + "<br /><b>" + line.orderLine.itemInfo.barcodes.join(", ") + "</b></small><span>" +
                    "<span class='qty'><b style='color: #fff'>" + line.qty + " " + SP.UnitType[line.orderLine.itemInfo.unitType] + "</b></span>"
                "</div>";
            }

            //clear
            this.oid_labels.innerHTML = "";
            var lastMethod = "none";
            for (let i = 0; i < shipment.packages.length; i++) {

                let pi = shipment.packages[i];

                let packageBox = document.createElement("div");
                packageBox.classList.add("box", "shipping_label");
                packageBox.innerHTML = "<div class='label_info'><b style='color: #fff'>" + pi.deliveryMethodName + "</b><br />" + pi.trackingNumber + "</div>";

                let printBtn = document.createElement("div");
                printBtn.classList.add("button", "label");
                printBtn.innerHTML = SP.Localize("word_reprint");

                printBtn.addEventListener("click", async () => {

                    if (!await SP.confirmX(SP.Localize("text_confirm_double_label_print")!!!)) return;



                    printBtn.classList.add("disabled");

                    if (!App_Settings.terminalSettings.label_printer) {
                        SP.alertX(SP.Localize("sentance_please_select_printer"));
                        return;
                    }

                    var result = await SP.get<any>("/api/v1/package/print/" + pi.id + "?label_printer=" + App_Settings.terminalSettings.label_printer + "&etiquette_printer=" + App_Settings.terminalSettings.etiquette_printer + "&a4_printer=" + App_Settings.terminalSettings.a4_printer);
                    console.log("print result", result);
                    if (result.status != 200) {
                        await SP.alertX(result.status + ": " + result.msg + (result.exception ? " - " + result.exception : ""));
                    }
                    printBtn.classList.remove("disabled");
                });


                let printNoteBtn = document.createElement("div");
                printNoteBtn.classList.add("button", "label", "note");
                printNoteBtn.innerHTML = "🧾";

                printNoteBtn.addEventListener("click", async () => {
                    printNoteBtn.classList.add("disabled");

                    if (!App_Settings.terminalSettings.label_printer) {
                        SP.alertX(SP.Localize("sentance_please_select_printer"));
                        return;
                    }

                    var result = await SP.get<any>("/api/v1/package/printnote/" + pi.id + "?label_printer=" + App_Settings.terminalSettings.label_printer + "&etiquette_printer=" + App_Settings.terminalSettings.etiquette_printer + "&a4_printer=" + App_Settings.terminalSettings.a4_printer);
                    console.log("print result", result);
                    if (result.status != 200) {
                        await SP.alertX(result.status + ": " + result.msg + (result.exception ? " - " + result.exception : ""));
                    }
                    printNoteBtn.classList.remove("disabled");
                });
                packageBox.appendChild(printNoteBtn);


                packageBox.appendChild(printBtn);
                lastMethod = pi.deliveryMethodId;
                this.oid_labels.appendChild(packageBox);
            }


            //clear deliverymethods
            this.oid_delivery_methods.innerHTML = "";

            for (let key in customer.deliveryMethods) {
                let m = customer.deliveryMethods[key];
                let disabled = false;

                if (m.orderSources.length && !m.orderSources.includes(shipment.order.orderSource)) continue;


                var destinationCountry = shipment.order.recipient.country.toUpperCase();
                var localPrices = m.prices[destinationCountry]

                if (!localPrices) {
                    disabled = true;
                }

                var opt = document.createElement("option");
                opt.text = m.name;
                opt.value = m.id;
                opt.disabled = disabled;
                opt.selected = m.id == lastMethod;

                console.log("ADDING:", opt);
                this.oid_delivery_methods.appendChild(opt);
            }

            this.updateParcelTypes();
        }

        async printDeliveryNote() {
            this.oid_print_note_button.classList.add("disabled");
            if (!App_Settings.terminalSettings.label_printer) {
                SP.alertX(SP.Localize("sentance_please_select_printer"));
                return;
            }

            var result = await SP.post<any>("/api/v1/shipment/printnote/" + this.shipment.shipmentId,
                {
                    label_printer: App_Settings.terminalSettings.label_printer,
                    etiquette_printer: App_Settings.terminalSettings.etiquette_printer,
                    a4_printer: App_Settings.terminalSettings.a4_printer,
                }
            );


            this.oid_print_note_button.classList.remove("disabled");
        }

        async printExtra() {
            this.oid_print_extra_button.classList.add("disabled");
            if (!App_Settings.terminalSettings.label_printer) {
                SP.alertX(SP.Localize("sentance_please_select_printer"));
                return;
            }


            let postData = {
                orderId: this.shipment.order.orderId,
                shipmentId: this.shipment.shipmentId,
                width: parseInt(this.oid_extra_width.value),
                length: parseInt(this.oid_extra_length.value),
                height: parseInt(this.oid_extra_height.value),
                weight: parseInt(this.oid_extra_weight.value),
                deliveryMethodId: this.oid_delivery_methods.value,
                parcelType: this.oid_parcel_type.value,
                packagingId: SP.Guid.Empty,
                referenceNo: this.shipment.order.referenceNo,
                orderNo: this.shipment.order.orderNo,
                deliveryInstructions: this.shipment.order.deliveryInstructions,
                fulfillmentLocation: this.shipment.fulfillmentLocation,
                initialize: true,
                preCommit: true,
                lines: {}
            }

            var createResult = await SP.post<any>("/api/v1/package/create", postData);
            console.log("create result:", createResult);



            if (createResult.status == 200) {
                var result = await SP.get<any>("/api/v1/package/print/" + createResult.packageId + "?label_printer=" + App_Settings.terminalSettings.label_printer + "&etiquette_printer=" + App_Settings.terminalSettings.etiquette_printer + "&a4_printer=" + App_Settings.terminalSettings.a4_printer);
                console.log("print result", result);
                if (result.status == 200) {
                    await this.load(this.shipment.shipmentId);
                }
                else {
                    await SP.alertX(result.status + ": " + result.msg + (result.exception ? " - " + result.exception : ""));
                }
            }
            else {

                await SP.alertX(createResult.status + ": " + createResult.msg + (createResult.exception ? " - " + createResult.exception : ""));
            }





            this.oid_print_extra_button.classList.remove("disabled");
        }

        close() {
            this.container.style.display = "none";

        }

    }

    let OID = new ShipmentInfoDialog();

    let ColorArray = ['#e6194B', '#3cb44b', '#4363d8', '#f58231', '#911eb4', '#f032e6', '#469990', '#9A6324', '#800000', '#808000', '#000075', '#000000'];
    export class ToteBox {
        container = document.createElement("div");
        info: SP.ToteInfo;
        parent: HTMLElement;
        constructor(info: SP.ToteInfo) {
            this.container.classList.add("tote_box");
            this.info = info;

            if (info?.pickSettings) {
                var color = ColorArray[info.pickListId % ColorArray.length];
                this.container.innerHTML += "<div class='profileInfo' style='background-color:" + color + "'>" + info.pickSettings?.name + "</div>";
            }
            this.container.innerHTML += "<img src='/terminal/img/tote_small.png' />" + info.toteName;
            this.container.style.backgroundColor = info.toteColor;

            var now = new Date();
            var triggerDate = new Date((info.orderDeadline * 1000) - (1000 * 60 * 60 * 3));
            var endTriggerDate = new Date((info.orderDeadline * 1000) + (1000 * 60 * 60 * 1));
            var show = triggerDate < now && now < endTriggerDate;
            // Hours part from the timestamp


            if (info?.blockPacker) {
                var dl_container = this.container.appendChild(document.createElement("span"));
                dl_container.classList.add("deadline");
                dl_container.innerHTML = SP.Localize("word_blocked");
            }

            if (info?.warningInfo) {
                var dl_container = this.container.appendChild(document.createElement("span"));
                dl_container.classList.add("deadline");
                dl_container.innerHTML = info.warningInfo;
            }
            else if (show) {
                if (info) {
                    var deadline = new Date(info.orderDeadline * 1000);
                    var hours = deadline.getHours();
                    var minutes = "0" + deadline.getMinutes();
                    var formattedTime = hours + ':' + minutes.substr(-2);
                    var dl_container = this.container.appendChild(document.createElement("span"));
                    dl_container.classList.add("deadline");
                    dl_container.innerHTML = formattedTime;
                }
            }

      




        }

        load(info: SP.ToteInfo) {
            //order details?

            //this.info = info;
            //container.innerHTML = info.toteName;
            //container.style.backgroundColor = info.toteColor;
        }


        setParent(elm: HTMLElement) {
            if (this.parent == elm) return;
            if (this.parent) container.remove();
            this.parent = elm;
            this.parent.appendChild(this.container);
        }
    }

    export class OrderHistoryItem {
        container = document.createElement("div");
        tote = document.createElement("div");
        info: SP.HistoryShipmentInfo;
        parent: HTMLElement;
        constructor(info: SP.HistoryShipmentInfo) {
            this.info = info;
            this.container.innerHTML = "<span><b>" + info.customer + "</b><br><b>" + info.orderNo + "</b> " + info.recipientName + "<br /><small>" + info.time + "</small><br></span>";
            this.container.classList.add("history_box");


            this.tote.innerHTML = "<img src='/terminal/img/tote_small.png' />" + info.toteName;
            this.tote.style.backgroundColor = info.toteColor;
            this.tote.style.float = "left";
            this.tote.classList.add("tote_box");
            this.container.prepend(this.tote);


            this.container.addEventListener("click", () => {
                OID.load(this.info.id);
            })
        }

    }

    export class App_Pack_Tote_List extends AppBase {
        static Instance: App_Pack_Tote_List;
        ptl_info = document.getElementById("ptl_info");
        ptl_headline = document.getElementById("ptl_headline");
        ptl_error = document.getElementById("ptl_error");
        ptl_totes = document.getElementById("ptl_totes");
        ptl_pending = document.getElementById("ptl_pending");
        ptl_history = document.getElementById("ptl_history");
        ptl_history_button = document.getElementById("ptl_history_button");
        ptl_totes_content = document.getElementById("ptl_totes_content");
        ptl_trolly_content = document.getElementById("ptl_trolly_content");
        ptl_pending_content = document.getElementById("ptl_pending_content");
        ptl_history_content = document.getElementById("ptl_history_content");
        ptl_search = document.getElementById("ptl_search") as HTMLInputElement;
        totes: { [id: number]: ToteBox } = {};
        bound = false;

        constructor() {
            super("app_pack_tote_list");
            App_Pack_Tote_List.Instance = this;


            this.ptl_history_button.addEventListener("click", () => {
                var visible = this.ptl_history.style.display == "block";
                this.ptl_history.style.display = visible ? "none" : "block";
                this.ptl_totes.style.display = visible ? "block" : "none";

                if (visible)
                    this.ptl_history_button.querySelector(".fa-solid").setAttribute("class", "fa-solid fa-clock-rotate-left");
                else
                    this.ptl_history_button.querySelector(".fa-solid").setAttribute("class", "fa-solid fa-inbox");
            });

            let to: any = null;
            this.ptl_search.addEventListener("keyup", () => {
                clearTimeout(to);
                to = setTimeout(() => {
                    this.load(this.ptl_search.value);
                }, 500);
            });
        }

        async onOpen() {
            this.ptl_search.value = "";

            //bind events and groups
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("t", this.scanTote, this);
                barcodeListener.on("tr", this.setTrolley, this);
                barcodeListener.on(null, this.scanBarcode, this);
            }

            await this.load('');

        }

        async onClose() {
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("t", this.scanTote);
                barcodeListener.off("tr", this.setTrolley);
                barcodeListener.off(null, this.scanBarcode);
            }
            this.reset();
        }

        async load(keyword: string) {
            this.reset();
            let active = await SP.Data.Tote.getActiveToteInfos(keyword);

            active.sort((a, b) => {

                if (App_Settings.terminalSettings.tote_sorting == "picklist") {
                    let listSort = a.pickListId > b.pickListId ? 1 : a.pickListId < b.pickListId ? -1 : 0;
                    if (listSort != 0) return listSort;
                }

                let groupSort = a.toteGroupName.localeCompare(b.toteGroupName);
                if (groupSort != 0) return groupSort;

                return a.toteId - b.toteId;
            });


            let history = await SP.Data.Shipment.getHistoryShipmentInfo("", keyword);
            active.forEach(t => this.updateInfo(t));
            history.forEach(t => this.addHistory(t));

            this.setTrolley(this.trolleyId);
        }

        historyDictionary: { [id: string]: OrderHistoryItem } = {};

        addHistory(info: SP.HistoryShipmentInfo) {
            let current = new OrderHistoryItem(info);
            this.ptl_history_content.appendChild(current.container);
            this.historyDictionary[current.info.id] = current;
        }

        showAllButton: HTMLElement;
        showAllButtonLabel: HTMLElement;

        updateInfo(info: SP.ToteInfo) {
            var current = this.totes[info.toteId];

            if (!current) {
                current = new ToteBox(info);
                current.container.addEventListener("click", () => {
                    App_Pack_Tote_List.Instance.scanTote(info.toteId.toString(), true);
                })
                this.totes[info.toteId] = current;
            }

            current.load(info);
            var parent = this.ptl_totes_content;


            if (info.trolleyId) {
                parent = this.trolleyContainers[info.trolleyId];
                if (parent == null) {
                    var elm = document.createElement("div");
                    elm.innerHTML = `<h1>${info.trolleyName}</h1><div class='trolley_content inactive trolley_${info.trolleyId}'></div>"`;
                    this.trolleyContainers[info.trolleyId] = parent = elm.querySelector(".trolley_content");

                    elm.querySelector("h1").addEventListener("click", () => {
                        this.setTrolley(info.trolleyId);

                    });
                    this.ptl_trolly_content.appendChild(elm);
                }
            }

            if (!info.readyForPack) parent = this.ptl_pending_content;

            current.setParent(parent);


            if (App_Settings.wmsSettings.fulfillment_location != 'global' && info.pickSettings?.fulfillmentLocation != App_Settings.wmsSettings.fulfillment_location) {
                current.container.style.display = "none";
                
            }

            //check if any has display none
            var hiddenCount = 0;
            for (let id in this.totes) {
                if (this.totes[id].info.readyForPack && this.totes[id].container.style.display == "none") {
                    hiddenCount++;
                }
            }

            if (hiddenCount > 0) {
                if (!this.showAllButton) {
                    this.showAllButton = this.ptl_totes.appendChild(createListButton("profile_list_button", SP.Localize("sentance_other_fulfillment_locations"), async () => {
                        if (await SP.confirmX(SP.Localize("word_show") + ' ' + SP.Localize("sentance_other_fulfillment_locations") + '?')) {
                            //show all hidden buttons and hide this
                            for (var id in this.totes) {
                                this.totes[id].container.style.display = "inline-block";
                            }
                            this.showAllButton.style.display = "none";
                        }
                    }));
                    this.showAllButton.style.backgroundColor = "#cfcfcf";
                    var label = this.showAllButtonLabel = this.showAllButton.appendChild(document.createElement("span"));
                    label.classList.add("label");
                }
                this.ptl_totes.appendChild(this.showAllButton);
                this.showAllButton.style.display = "flex";
                this.showAllButtonLabel.innerHTML = hiddenCount.toString();

            }
        }

        trolleyContainers: { [key: number]: HTMLElement } = {};
        trolleyId: number = null;


        async setTrolley(trolleyId: number) {
            if (trolleyId != this.trolleyId) { 
                this.trolleyId = trolleyId;

                if (trolleyId) {
                    var trolley = await SP.Data.Trolley.getTrolleyInfo(trolleyId);
                    Talk(trolley.name);
                }
            }

            for (let id in this.trolleyContainers) {
                let child = this.trolleyContainers[id];
                child.classList.add("inactive");
                if (trolleyId && id == trolleyId.toString()) {
                    child.classList.remove("inactive");
                    child.parentElement.parentElement.insertBefore(child.parentElement, child.parentElement.parentElement.firstChild); //move to top
                }
            }

            if (!this.trolleyContainers[this.trolleyId]) this.trolleyId = null;
        }

        reset() {
            this.totes = {};
            this.ptl_totes_content.innerHTML = "";
            this.ptl_trolly_content.innerHTML = "";
            this.trolleyContainers = {};
            this.ptl_pending_content.innerHTML = "";
            this.ptl_history_content.innerHTML = "";
        }

        async scanTote(id: string, manual_click: boolean = false) {

            //get tote info
            var tote = await SP.Data.Tote.getToteInfo(id, false);

            if (tote.trolleyId && tote.trolleyId != this.trolleyId) {
                this.showError("Wrong Trolley");
                return;
            }

            //check if ready
            if (!tote.readyForPack) return this.showError("tote not ready for packing!");


            if (document.querySelector(".phone"))
                SP.setAllHash({ "app": "app_fast_pack_order", "tote": id, "clicked": manual_click.toString() });
            else
                SP.setAllHash({ "app": "app_pack_order", "tote": id, "clicked": manual_click.toString() });

        }



        async scanBarcode(barcode: string, gs1Data: SP.GS1Data) {

            //get tote info
            let grouppickTote = await SP.Data.Tote.getToteInfoGroupedPick(encodeURIComponent(barcode), this.trolleyId);


            //pick tote
            if (grouppickTote != null) {

                if (grouppickTote.trolleyId && grouppickTote.trolleyId != this.trolleyId) {
                    this.showError("Wrong Trolley");
                    return;
                }


                if (document.querySelector(".phone")) {
                    SP.setAllHash({ "app": "app_fast_pack_order", "tote": grouppickTote.toteId.toString(), "barcode": barcode });
                }
                else {
                    SP.setAllHash({ "app": "app_pack_order", "tote": grouppickTote.toteId.toString(), "barcode": barcode });
                }

                return;
            }



            let historyMatches = await SP.Data.Shipment.getHistoryShipmentInfo(barcode);
            let toteMatches = await SP.Data.Tote.getToteInfosBarcode(barcode ?? "", gs1Data?.orderNumber ?? gs1Data?.batchOrLotNumber ?? "");

            var matchCount = historyMatches.length + toteMatches.length;

            //blink history matches
            for (let i = 0; i < historyMatches.length; i++) {
                let match = this.historyDictionary[historyMatches[i].id];
                if (match) {
                    match.container.parentElement.prepend(match.container);
                    match.container.classList.add("blink_effect");
                    setTimeout(() => {
                        match.container.classList.remove("blink_effect");
                    }, 10000);
                }

            }


            //blink tote matches
            for (let i = 0; i < toteMatches.length; i++) {
                var tote = toteMatches[i];
                let match = this.totes[tote.toteId];
                if (match) {
                    match.container.parentElement.prepend(match.container);
                    match.container.classList.add("blink_effect");
                    setTimeout(() => {
                        match.container.classList.remove("blink_effect");
                    }, 10000);
                }
                if (matchCount == 1) Talk("Tote " + tote.toteName);

            }


            if (toteMatches.length == 0 && historyMatches.length == 0) SP.Sounds.Error.play();
        }



        //error handling
        errorN: number = 0;
        async showError(message: string) {
            this.errorN++;
            let en = this.errorN;

            this.ptl_error.textContent = message;
            this.ptl_error.style.display = "block";
            this.ptl_headline.style.display = "none";
            SP.Sounds.Error.play();
            await SP.sleep(3000);
            if (en == this.errorN) {
                this.ptl_error.style.display = "none";
                this.ptl_headline.style.display = "block";
            }
        }
    }




    RegisterApp("app_pack_tote_list", App_Pack_Tote_List);

}